import styled from 'styled-components';

const Container = styled.div`
  padding: 0 8.625rem;
  margin: 0 auto;
  min-height: 100vh;

  @media screen and (max-width: 1200px) {
    padding: 0 ${({ theme }) => theme.spacing.layoutxl};
  }

  @media screen and (max-width: 1020px) {
    padding: 0 1.5rem;
    gap: 0;
    justify-content: center;
  }
  
`;

export default Container;
